import React from 'react';

function IconPlus({
  width = '1rem',
  style,
  viewBox = '0 0 24 24',
  className,
}) {
  return (
    <svg
      width={width}
      style={style}
      height={width}
      viewBox={viewBox}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <use xlinkHref="#icon_plus" />
    </svg>
  );
}
export default IconPlus;
